export default "__VITE_ASSET__CDSeFxfC__"